import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import styles from './DeleteUserDialog.module.css';

const DeleteUserDialog = () => {
  const { userManagementStore, popupStore } = useStore();
  const selectedUser = userManagementStore.selectedUser;

  const handleClose = () => {
    popupStore.setIsDeleteUserConfirmationOpen(false);
    userManagementStore.setSelectedUser(null);
  };

  const handleConfirm = async () => {
    if (!selectedUser?.id) {
      return;
    }

    try {
      await userManagementStore.deleteUser(selectedUser.id);
      handleClose();
    } catch (error) {
      console.error('Delete error:', error);
    }
  };

  const message = selectedUser ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki kullanıcıyı silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Kullanıcı Adı</span>
          <span className={styles.detailValue}>{selectedUser.userName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>E-posta</span>
          <span className={styles.detailValue}>{selectedUser.email || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Roller</span>
          <span className={styles.detailValue}>
            {selectedUser.roles?.length ? selectedUser.roles.join(', ') : '—'}
          </span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Durum</span>
          <span className={styles.detailValue}>
            {selectedUser.isActive ? 'Aktif' : 'Pasif'}
          </span>
        </li>
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeleteUserConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Kullanıcı Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeleteUserDialog);
